import {
	BrandPrimaryColor,
	getStoreName,
	RelyingParty,
	relyingPartyDefaults,
} from '@pcid/utils/relying-party-utils';

const environment = window.pcid.ENVIRONMENT === 'prod' ? 'prod' : 'dev';

export default {
	...relyingPartyDefaults,
	storeName: getStoreName(RelyingParty.ACCOUNT_MANAGEMENT),
	forgotPasswordURL: `${window.origin}/forgot-password`,
	updateEmail: true,
	symbol: 'pc-id',
	color: BrandPrimaryColor.WHITE,
	casl: false,
	caslMsg: `rp.${RelyingParty.ACCOUNT_MANAGEMENT}.casl`,
	collectName: false,
	confirmLogin: false,
	createAccountURL: environment === 'prod' ? '' : '/create-account',
};
